import { render, staticRenderFns } from "./TranslationInput.vue?vue&type=template&id=e72a0aa0&scoped=true"
import script from "./TranslationInput.vue?vue&type=script&lang=js"
export * from "./TranslationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72a0aa0",
  null
  
)

export default component.exports